document.addEventListener('DOMContentLoaded', () => {
  const bars = document.querySelectorAll('[data-crg-mobile-buybar]');
  if (!bars.length) return;

  bars.forEach((bar) => {
    const sectionId = bar.dataset.sectionId;
    const mainButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const info = document.getElementById(`ProductInfo-${sectionId}`);
    const stickyButton = bar.querySelector('[data-crg-sticky-add]');
    const stickyPrice = bar.querySelector('[data-crg-sticky-price]');
    if (!mainButton || !info || !stickyButton) return;

    const sync = () => {
      stickyButton.disabled = mainButton.disabled;
      stickyButton.textContent = mainButton.querySelector('span')?.textContent?.trim() || 'ADD TO CART';
      const livePrice = info.querySelector('[id^="price-"] .price-item--regular, [id^="price-"] .price-item--sale');
      if (livePrice && stickyPrice) stickyPrice.textContent = livePrice.textContent.trim();
    };

    stickyButton.addEventListener('click', () => mainButton.click());

    let mainVisible = true;
    let productEntered = false;
    const refresh = () => {
      const visible = productEntered && !mainVisible;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };

    const buttonObserver = new IntersectionObserver((entries) => {
      mainVisible = entries[0]?.isIntersecting ?? true;
      refresh();
    }, { threshold:0.01 });
    buttonObserver.observe(mainButton);

    const infoObserver = new IntersectionObserver((entries) => {
      if (entries[0]?.isIntersecting) productEntered = true;
      refresh();
    }, { rootMargin:'0px 0px -28% 0px', threshold:0.01 });
    infoObserver.observe(info);

    const priceNode = info.querySelector('[id^="price-"]');
    const mutation = new MutationObserver(sync);
    mutation.observe(mainButton, { childList:true, subtree:true, attributes:true, attributeFilter:['disabled'] });
    if (priceNode) mutation.observe(priceNode, { childList:true, subtree:true, characterData:true });
    sync();
  });
});

// Club Rehab visual variant picker search + selected label helper
(() => {
  const bindCrgVisualVariantPickers = (root = document) => {
    const pickers = root.querySelectorAll('[data-crg-visual-picker]');
    if (!pickers.length) return;
    pickers.forEach((picker) => {
      if (picker.dataset.crgBound === 'true') return;
      picker.dataset.crgBound = 'true';
      const search = picker.querySelector('[data-crg-variant-search]');
      const selected = picker.querySelector('[data-selected-value]');
      if (search) {
        search.addEventListener('input', () => {
          const q = search.value.trim().toLowerCase();
          picker.querySelectorAll('[data-crg-variant-option]').forEach((tile) => {
            tile.hidden = !!q && !((tile.dataset.valueText || '').includes(q));
          });
        });
      }
      picker.addEventListener('change', (event) => {
        if (event.target.matches('input[type="radio"]') && selected) selected.textContent = event.target.value;
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bindCrgVisualVariantPickers());
  else bindCrgVisualVariantPickers();
  document.addEventListener('shopify:section:load', (e) => bindCrgVisualVariantPickers(e.target));
})();

// Club Rehab V79: keep the primary purchase controls beside the price.
(() => {
  const placeFastBuyRow = (root = document) => {
    root.querySelectorAll('[id^="MainProduct-"]').forEach((section) => {
      const info = section.querySelector('[id^="ProductInfo-"]');
      if (!info || info.querySelector('.crg-price-buy-row')) return;

      const price = info.querySelector('[id^="price-"]');
      const quantity = info.querySelector('.product-form__quantity');
      const productForm = info.querySelector('product-form.product-form');
      if (!price || !productForm) return;

      const row = document.createElement('div');
      row.className = 'crg-price-buy-row';
      price.parentNode.insertBefore(row, price);

      row.appendChild(price);
      if (quantity) row.appendChild(quantity);
      row.appendChild(productForm);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => placeFastBuyRow());
  } else {
    placeFastBuyRow();
  }
  document.addEventListener('shopify:section:load', (event) => placeFastBuyRow(event.target));
})();
